module.exports = __webpack_public_path__ + "event.svg?a449fa6aa24fd4b45bb9cdc7f891abd2";